import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import { useSuperAdminOrganization } from "../../../context/SuperAdmin/OrganizationContext";
import SearchIcon from "@mui/icons-material/Search";

const HeadersOrgTable = () => {
  const { handleSearchChange, searchQuery, toggleCreateModal } = useSuperAdminOrganization();
  return (
    <Grid
      container
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <Grid item>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Ej: Colegio San José"
          value={searchQuery}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          onClick={() => toggleCreateModal(true)}
          sx={{ background: "#336B87" }}
        >
          + Crear organización
        </Button>
      </Grid>
    </Grid>
  );
};

export default HeadersOrgTable;
